import { render, staticRenderFns } from "./syncStatus.vue?vue&type=template&id=2ea1694e&scoped=true"
import script from "./syncStatus.vue?vue&type=script&lang=js"
export * from "./syncStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea1694e",
  null
  
)

export default component.exports